import { ROAST_TYPES, type ImportRow, type RowError } from './types';

const UUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function validateAll(rows: ImportRow[]): RowError[] {
  const errs: RowError[] = [];
  rows.forEach((row, rowIndex) => {
    if (!row.sourceGreenBeanItemId || !UUID_RE.test(row.sourceGreenBeanItemId)) {
      errs.push({
        rowIndex,
        field: 'sourceGreenBeanItemId',
        message: 'Source green bean is required (fix in Excel and re-upload)',
      });
    }
    if (!Number.isFinite(row.initialQty) || row.initialQty <= 0) {
      errs.push({ rowIndex, field: 'initialQty', message: 'Stock must be greater than 0' });
    }
    if (!Number.isFinite(row.standardCost) || row.standardCost < 0) {
      errs.push({ rowIndex, field: 'standardCost', message: 'Standard cost must be ≥ 0' });
    }
    if (!(ROAST_TYPES as readonly string[]).includes(row.roastType)) {
      errs.push({ rowIndex, field: 'roastType', message: 'Roast type is required' });
    }
  });
  return errs;
}
